/*
 * Shim for Shopify's platform-hosted option_selection.js.
 *
 * WHY THIS EXISTS
 * ---------------
 * `Shopify.Product.prototype.update` has always been written with an
 * undeclared loop variable:
 *
 *     Shopify.Product.prototype.update = function (json) {
 *       for (property in json) { this[property] = json[property]; }
 *     };            ^^^^^^^^ no `var`
 *
 * That was harmless for years because the file was served in sloppy mode, so
 * `property` quietly became an implicit global. Shopify has since rebuilt the
 * asset wrapped in `"use strict";(() => { ... })()`, and in strict mode an
 * assignment to an undeclared identifier throws:
 *
 *     ReferenceError: property is not defined
 *
 * Every `new Shopify.OptionSelectors(...)` call now throws. In this theme that
 * kills `window.productPage.runOptionSelector()`, which is partway down a
 * single unguarded init chain in app.js -- so the throw also takes out
 * `initializeQuantityBox`, `recentlyViewed`, `sidebarAccordions`,
 * `currencyConverter` and `productSwatches`. `productSwatches` is what adds
 * `.is-visible` to `.product_form`, so the buy box was left at `opacity: 0`
 * on every product page: invisible and unclickable. (2026-09-04)
 *
 * The fix is the missing `var`. We redefine the one broken method and leave the
 * rest of Shopify's file alone.
 *
 * LOAD ORDER: must run after option_selection.js and before DOMContentLoaded.
 * Both are `defer`red and deferred scripts execute in document order, so the
 * tag for this file has to stay immediately after the option_selection.js tag
 * in layout/theme.liquid.
 *
 * REMOVING THIS: safe to delete once Shopify ships a corrected
 * option_selection.js. Test by deleting it and loading a product page -- if the
 * Add to Cart button is visible and the console is free of "property is not
 * defined", the platform bug is gone.
 */
(function () {
  if (!window.Shopify || !Shopify.Product || !Shopify.Product.prototype) {
    return;
  }

  Shopify.Product.prototype.update = function (json) {
    for (var property in json) {
      if (Object.prototype.hasOwnProperty.call(json, property)) {
        this[property] = json[property];
      }
    }
  };
})();
